import {
  Box,
} from '@material-ui/core'
import React, { useState } from 'react'
import { useHistory } from 'react-router-dom'
import { FormProvider, useForm } from 'react-hook-form'
import { useSnackbar } from 'notistack'
import { Helmet } from 'react-helmet'
import { yupResolver } from '@hookform/resolvers/yup'
import Cookies from 'js-cookie'
import application from '@config/application'
import { resellerApi } from '@api/baseApi'
import { schema, rules } from '@config/yup.schema'
import LoginForm from '@components/LoginForm'
import getDomain from '@config/domain'
import useStyles from './login-jss'

const Login = () => {
  const classes = useStyles()
  const methods = useForm({
    resolver: yupResolver(schema({
      username: rules.email,
      password: rules.password,
    })),
  })
  const { enqueueSnackbar } = useSnackbar()
  const [isSubmitting, setSubmitting] = useState(false)
  const history = useHistory()
  // eslint-disable-next-line no-unused-vars
  const onSubmit = async (value) => {
    const params = {
      ...value,
      scope: 'reseller',
      grant_type: 'password',
      domain: getDomain(),
    }

    try {
      setSubmitting(true)
      const { status, data } = await resellerApi.post('/oauth/token', params)
      if (status === 200) {
        setSubmitting(false)
        // eslint-disable-next-line camelcase

        await Cookies.set('reseller_app_token', data?.access_token, { expires: 1 })
        await Cookies.set('scope', data?.scope)
        await localStorage.setItem('payload', JSON.stringify(data?.data))

        enqueueSnackbar('Login Berhasil', { variant: 'success' })
        history.push(`${application.prefix}${application.path}/dashboard`)
      }
    } catch (error) {
      setSubmitting(false)
      enqueueSnackbar(
        error.response?.data?.error || 'Maaf terjadi kesalahan, Silahkan coba kembali beberapa saat lagi',
        { variant: 'error' },
      )
    }
  }

  return (
    <Box className={classes.root}>
      <Helmet>
        <title>{window.location.host} - Login</title>
      </Helmet>
      <FormProvider {...methods}>
        <LoginForm
          isSubmitting={isSubmitting}
          onSubmit={onSubmit}
        />
      </FormProvider>
    </Box>
  )
}

export default Login
